"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var BatchCreateService = /** @class */ (function () {
    function BatchCreateService(DrivesModel) {
        this.drive = null;
        this.DrivesModel = DrivesModel;
        this.momentIterate = this.momentIterate.bind(this);
        this.setDrive = this.setDrive.bind(this);
        this.getDrive = this.getDrive.bind(this);
    }
    BatchCreateService.prototype.setDrive = function (drive) {
        this.drive = drive;
        return this.drive;
    };
    BatchCreateService.prototype.getDrive = function () {
        return this.drive;
    };
    BatchCreateService.prototype.getCourse = function () {
        return this.course;
    };
    BatchCreateService.prototype.setCourse = function (course) {
        this.course = course;
    };
    BatchCreateService.prototype.getContext = function () {
        return this.context;
    };
    BatchCreateService.prototype.setContext = function (data) {
        this.context = data;
    };
    BatchCreateService.prototype.getBatchMethod = function (data, context) {
        switch (context) {
            case "drive":
                return this.DrivesModel.batchCreate(data);
                break;
            case "event":
                break;
            case "course":
                break;
        }
    };
    // http://stackoverflow.com/questions/22929204/iterate-throught-between-two-dates-in-javascript
    BatchCreateService.prototype.momentIterate = function (options, originalAppointment) {
        var drives = [];
        if (typeof options.days === "undefined") {
            options.days = {
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
                sunday: true,
            };
        }
        var startDate = (0, moment_1.default)(options.startDate);
        var endDate = (0, moment_1.default)(options.endDate);
        for (var date = (0, moment_1.default)(startDate); date.diff(endDate, "days") < 1; date.add(1, "days")) {
            var formattedDateKey = date.format("dddd").toLowerCase();
            if (typeof options.days[formattedDateKey] !== "undefined" &&
                options.days[formattedDateKey] === true) {
                var newDriveSession = Object.assign({}, originalAppointment);
                newDriveSession.formatDate = date.format("YYYY-MM-DD");
                newDriveSession.formatTime = (0, moment_1.default)(originalAppointment.time).format("HH:mm");
                drives.push(newDriveSession);
            }
        }
        return drives;
    };
    BatchCreateService.prototype.getEvent = function () {
        return this.event;
    };
    BatchCreateService.prototype.setEvent = function (event) {
        this.event = event;
    };
    return BatchCreateService;
}());
BatchCreateService.$inject = ["DrivesModel"];
exports.default = BatchCreateService;
